[
  "cursor-grok-4.6-high",
  "composer-2.5",
  "composer-2.5-fast"
]
